import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const useGetLabels = ()=>{
    const { getLabel , hasLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            loadingMessage: getLabel('checkout.order.loadingMessage'),
            paymentMethodTitle: getLabel('checkout.payment.method.title'),
            paymentMethodSecure: hasLabel('checkout.payment.method.secure') ? getLabel('checkout.payment.method.secure') : ''
        })
    , [
        getLabel,
        hasLabel
    ]);
    return [
        labels
    ];
};

export { useGetLabels };
//# sourceMappingURL=use-get-labels.js.map
